import {
  base_colorContentBorder,
  blue100,
  blue400,
  notification_colorAlert,
  purple200,
  purple500,
  tag_colorTagSevereBackground,
  yellow50,
  yellow200,
  yellow800,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing(3)};
  padding: ${spacing(4)} ${spacing(5)};
  border-radius: ${cornerRadius};
  border: 1px solid ${base_colorContentBorder};

  &.topAlign {
    align-items: flex-start;
  }

  .AlertBanner-icon {
    display: flex;
    // prevent the icon getting squished when the rejection note is long
    flex-shrink: 0;
  }

  .AlertBanner-chevron {
    display: flex;
    // prevent the icon getting squished when the rejection note is long
    flex-shrink: 0;
    cursor: pointer;
  }

  .collapsible {
    margin-top: ${spacing(2)};
  }

  // VARIANTS
  &.soft {
    background-color: ${blue100};
    .AlertBanner-chevron > path {
      fill: ${blue400};
    }
  }

  &.warning {
    background-color: ${yellow50};
    color: ${yellow800};
    border: 1px solid ${yellow200};
    .AlertBanner-chevron > path {
      fill: ${yellow800};
    }
  }

  &.severe {
    background-color: ${tag_colorTagSevereBackground};
    .AlertBanner-chevron > path {
      fill: ${notification_colorAlert};
    }
  }

  &.new {
    background-color: ${purple200};
    .AlertBanner-chevron > path {
      fill: ${purple500};
    }
  }
`
